import _extends from "@babel/runtime/helpers/esm/extends";
import { internalDateLocale } from "../../../../../lib/date/localeSets";
import { LangCodes } from "../../../../../lib/locale";
export var componentsLocales = _extends({
  today: 'Today',
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
}, internalDateLocale[LangCodes.en_GB]);